import React, { useState } from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { populateTranslationData } from '../../helper/translationHelpers';
import { errorStore } from '../../stores/ErrorStore';
import { TranslationListDisplay } from './TranslationListDisplay';
import { TranslationDataStatsDisplay } from './TranslationDataStatsDisplay';
import { translationStore } from '../../stores/TranslationStore';
import { TranslationImportingPopup } from './TranslationImporting';
import { TranslationHeader } from './TranslationHeader';
import { wait } from '../../../shared/helper/generalHelpers';
import { readUnicodeText, readTextUsingEncodingLibrary } from '../../helper/fileHelpers';
var Method;

(function (Method) {
  Method["UTF8"] = "UTF8";
  Method["Unicode"] = "Unicode";
  Method["Detect"] = "Detect";
})(Method || (Method = {}));

export const TranslationImport = observer(() => {
  const {
    t
  } = useTranslation();
  const [method, setMethod] = useState(Method.Detect);
  const {
    translationData
  } = translationStore;

  const onFileSet = async e => {
    try {
      const {
        target
      } = e;
      const file = target.files[0];
      if (!file) return;
      translationStore.setTranslationData(null);
      await wait(1);
      let importCSV;

      switch (method) {
        case Method.UTF8:
          importCSV = await file.text();
          break;

        case Method.Unicode:
          importCSV = await readUnicodeText(file);
          break;

        case Method.Detect:
          importCSV = await readTextUsingEncodingLibrary(file);
          break;

        default:
          throw new Error("Not implemented: " + method);
      }

      target.value = null;
      translationStore.setTranslationData(populateTranslationData(file.name, importCSV));
    } catch (e) {
      errorStore.addErrorFromErrorObject(e);
    }
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TranslationHeader, {
    titleKey:
    /*t*/
    "translation.import"
  }), /*#__PURE__*/React.createElement("div", null, t("translation.upload_translation"), ":\xA0", /*#__PURE__*/React.createElement("select", {
    value: method,
    onChange: ({
      target
    }) => setMethod(target.value)
  }, /*#__PURE__*/React.createElement("option", {
    value: Method.Detect
  }, "Auto"), /*#__PURE__*/React.createElement("option", {
    value: Method.UTF8
  }, "UTF8"), /*#__PURE__*/React.createElement("option", {
    value: Method.Unicode
  }, "Unicode")), /*#__PURE__*/React.createElement("input", {
    type: "file",
    accept: "text/csv",
    onChange: onFileSet
  })), translationData && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    onClick: () => translationStore.setTranslationData(populateTranslationData(translationData.filename, translationData.importCSV))
  }, t("translation.reset_choices_and_reload"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, t("translation.loaded", {
    filename: translationData.filename
  })), /*#__PURE__*/React.createElement(TranslationDataStatsDisplay, null), /*#__PURE__*/React.createElement("button", {
    disabled: !translationStore.mayCommitChanges,
    onClick: () => translationStore.commitChanges().catch(errorStore.addErrorFromErrorObject)
  }, t("translation.commit_changes", {
    count: translationStore.commitActionCount
  }))), /*#__PURE__*/React.createElement(TranslationListDisplay, {
    titleKey:
    /*t*/
    "translation.translations",
    translations: translationData.translations,
    translationData: translationData
  }), /*#__PURE__*/React.createElement(TranslationListDisplay, {
    titleKey:
    /*t*/
    "translation.stats_translations_for_deleted_entities",
    translations: translationData.translationsForRemovedElements,
    translationData: translationData
  }), /*#__PURE__*/React.createElement(TranslationImportingPopup, null)));
});